import { FC, ReactNode, useContext, useEffect, useState } from 'react'
import clsx from 'clsx'

import statisticContext from 'context/statisticsContext'
import VideoBlock from 'components/webinar/video-block/video-block'
import Recommendations from 'containers/recommendations/recommendations'
import Commentaries from 'components/parts/commentaries/commentaries'
import WriteUs from 'components/parts/write-us/write-us-popup/write-us'
import WriteUsBtn from 'components/parts/write-us/write-us-btn/write-us-btn'
import WidthLimiter from 'containers/width-limiter/width-limiter'
import BreadcrumbsPage from 'components/parts/breadcrumb-page/breadcrumb-page'
import useLectorsSubscription from 'hooks/useLectorsSubscription'

import { URL_SITE } from 'constants/data'
import { PLACEFLAG_PAST, PLACEFLAG_VIDEO } from 'constants/analytic-data'
import { IMaterial } from 'constants/types/webinar.types'
import { SocketEvents } from 'constants/events'

import styles from './../articles.module.scss'
import stylesVideo from './article-video.module.scss'

interface IArticleVideo {
  dataset: IMaterial
  isWebinar?: boolean
  isWithFormat?: boolean
  children?: ReactNode
}

const ArticleVideo: FC<IArticleVideo> = (props: IArticleVideo) => {
  const [toggleFeedback, setToggleFeedback] = useState(false)
  const { dataset, isWebinar, isWithFormat, children } = props
  const place = isWebinar ? PLACEFLAG_PAST : PLACEFLAG_VIDEO
  const lectorsData = useLectorsSubscription(dataset.Lecturs, place)
  const socket = useContext(statisticContext)

  const handleToggleFeedback = () => setToggleFeedback((prevValue) => !prevValue)

  useEffect(() => {
    if (isWebinar && socket?.sendEvent) socket?.sendEvent(SocketEvents.WEBINAR_RECORD)
  }, [socket])

  return (
    <div className={stylesVideo.articleVideo}>
      <WriteUs toggleFeedback={toggleFeedback} setToggleFeedback={handleToggleFeedback} />
      <div className={styles.articleWrapper}>
        <div
          className={clsx(stylesVideo.articleTopVideo, {
            [stylesVideo.wrapperWithFormat]: isWithFormat,
          })}
        >
          {isWithFormat && (
            <section
              className={clsx(styles.recomendationSection, styles.recomendationSectionVertical)}
            >
              <WidthLimiter noTopPadding noBottomPadding noLeftPadding noRightPadding>
                <div>{children}</div>
              </WidthLimiter>
            </section>
          )}
          <WidthLimiter noTopPadding noBottomPadding noLeftPadding noRightPadding>
            <div className={stylesVideo.whiteBgVideo}>
              <main>
                <div className={stylesVideo.breadcrumb}>
                  <BreadcrumbsPage
                    breadData={[
                      {
                        name: isWebinar ? 'Вебинары' : 'Библиотека',
                        link: isWebinar ? `${URL_SITE}/webinar` : `${URL_SITE}/library`,
                      },
                      { name: dataset.name, link: '' },
                    ]}
                  ></BreadcrumbsPage>
                </div>
                <VideoBlock {...props} lectorsData={lectorsData} />
              </main>
            </div>

            {!dataset.isHideComments && (
              <div className={styles.commentariesTop}>
                <Commentaries
                  comments={dataset.Comments}
                  id={dataset.id}
                  materialType={isWebinar ? 'webinar' : 'article'}
                  isWithNMO={Boolean(dataset.activeNMOCodes)}
                  isAllowComment={dataset?.isAcceptAllow}
                />
                <div className={styles.writeUsBotom}>
                  <h3 className={styles.writeUsTitle}>Остались вопросы?</h3>
                  <WriteUsBtn handler={handleToggleFeedback} />
                </div>
              </div>
            )}
          </WidthLimiter>
          {!dataset.isHideRecommendations && (
            <section
              className={clsx(styles.recomendationSection, styles.recomendationSectionVertical)}
            >
              <WidthLimiter
                noTopPadding
                noBottomPadding
                noLeftPadding
                noRightPadding
                modificator={stylesVideo.widthLimMod}
              >
                <div>
                  <h2 className={styles.recommendationsTitle}>Рекомендации</h2>
                  <Recommendations
                    isVertical
                    noMargin
                    noPadding
                    isVerticalMobile
                    eventWrapperModificator={styles.eventWrapperModificator}
                  />
                </div>
              </WidthLimiter>
            </section>
          )}
        </div>
      </div>
      <div className={styles.commentariesBottom}>
        <WidthLimiter noTopPadding noBottomPadding>
          {!dataset.isHideComments && (
            <Commentaries
              comments={dataset.Comments}
              id={dataset.id}
              materialType={isWebinar ? 'webinar' : 'article'}
              isWithNMO={Boolean(dataset.activeNMOCodes)}
              isAllowComment={dataset?.isAcceptAllow}
            />
          )}
          <div className={styles.writeUsBotom}>
            <h3 className={styles.writeUsTitle}>Остались вопросы?</h3>
            <WriteUsBtn handler={handleToggleFeedback} />
          </div>
        </WidthLimiter>
      </div>
    </div>
  )
}

export default ArticleVideo
